import { useRef, useEffect } from "react";
import { parseISO, isValid, differenceInHours } from "date-fns";
import { enGB, de } from "date-fns/locale";
import memoize from "fast-memoize";
import { Language } from "../appointment-schedule.types.js";
const getLocale = (language) => {
  switch (language) {
    case Language.DEUTSCH: {
      return de;
    }
    default: {
      return enGB;
    }
  }
};
const usePrevious = (value) => {
  const ref = useRef();
  useEffect(() => {
    ref.current = value;
  }, [value]);
  return ref.current;
};
const isLessThanXHours = (time, hours = 24) => {
  const parsedTime = typeof time === "string" ? parseISO(time) : time;
  if (!isValid(parsedTime))
    throw new TypeError("Wrong time value passed");
  return differenceInHours(parsedTime, /* @__PURE__ */ new Date()) < hours;
};
const insertIf = (condition, elements) => condition ? [elements] : [];
const getNameInitials = (name = "", maxInitials) => {
  return name.trim().split(/\s+/).reduce((initials, word, index) => {
    if (!maxInitials || index < maxInitials) {
      initials.push(word.charAt(0).toUpperCase());
    }
    return initials;
  }, []).join("");
};
const toggleArray = (array = [], value) => {
  const exists = array.includes(value);
  return exists ? array.filter((item) => item !== value) : [...array, value];
};
const withQueryParams = (fetchFn) => (queryContext) => {
  const { queryKey, signal } = queryContext;
  const [, params] = queryKey;
  return fetchFn(params, signal);
};
const toEntities = memoize(
  (data, id, merge) => {
    if (!data)
      return {};
    return data.reduce((accumulator, current) => {
      const key = current[id];
      return {
        ...accumulator,
        [key]: merge ? [...accumulator[key] ?? [], current] : current
      };
    }, {});
  }
);
const flow = (arg, firstFn, ...fns) => {
  if (!firstFn) {
    throw new TypeError("pipe requires at least one function");
  }
  return fns.reduce((acc, fn) => fn(acc), firstFn(arg));
};
export {
  flow,
  getLocale,
  getNameInitials,
  insertIf,
  isLessThanXHours,
  toEntities,
  toggleArray,
  usePrevious,
  withQueryParams
};
